import axios from 'axios'
import { Message, Loading } from 'element-ui'
import { Local } from '@/utils/storage'

const URL = {
  // OPS: process.env.VUE_APP_BASE_API,
  MALL: window.location.origin + '/MALL',
}

console.log('Current Environment:', process.env.NODE_ENV)
console.log('Mall API:1', URL.MALL)

axios.defaults.timeout = 60000
let loadingInstance = null

axios.interceptors.request.use((config) => {
  loadingInstance = Loading.service({
    lock: true,
    text: '加载中',
    background: 'rgba(0, 0, 0, 0.6)'
  })

  config.headers['Content-Type'] = config.url.indexOf('/file/upload') !== -1
    ? 'application/x-www-form-urlencoded; charset=UTF-8'
    : 'application/json;charset=UTF-8'

  return config
})

const handleError = function (response) {
  let notification = null
  if (response && response.code) {
    notification = response.message ? response.message : ''
    switch (response.code) {
      case '500':
      case '400':
      case '300':
      case '401':
        notification = response.message
        break
    }
    Message.error(notification)
  }
}

axios.interceptors.response.use(
  (response) => {
    loadingInstance.close()
    if (response && response.status === 200) {
      return Promise.resolve(response)
    } else {
      console.log('response_error')
      handleError(response)
      return Promise.reject(response)
    }
  },
  (error) => {
    if (error.response.data.status === 401) {
      Message.error('登录已过期，请重新登录')
      Session.clear()
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    } else {
      loadingInstance.close()
      handleError(error)
      return Promise.reject(error)
    }
  }
)

/**
 * get方法，对应get请求
 * @param {String} url 请求的url地址
 * @param {Object} params 请求时携带的参数
 * @param {String} baseURL 基础URL，默认为'MALL'
 * @param {String} fileType 响应类型，默认为'json'
 * @returns {Promise}
 */
export function $get(url, params, baseURL = 'MALL', fileType = 'json') {
  return new Promise((resolve, reject) => {
    axios.defaults.baseURL = URL[baseURL]
    axios
      .get(url, {
        params: params,
        responseType: fileType
      })
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

/**
 * post方法，对应post请求
 * @param {String} url 请求的url地址
 * @param {Object} params 请求时携带的参数
 * @param {String} baseURL 基础URL，默认为'OPS'
 * @param {String} fileType 响应类型，默认为'json'
 * @returns {Promise}
 */
export function $post(url, params, baseURL = 'OPS', fileType = 'json') {
  return new Promise((resolve, reject) => {
    axios.defaults.baseURL = URL[baseURL]
    axios
      .post(url, params, {
        responseType: fileType
      })
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

/**
 * postObj方法，对应post请求
 * @param {String} url 请求的url地址
 * @param {Object} params 请求时携带的参数
 * @param {String} baseURL 基础URL，默认为'OPS'
 * @returns {Promise}
 */
export function $postObj(url, params, baseURL = 'OPS') {
  return new Promise((resolve, reject) => {
    axios.defaults.baseURL = URL[baseURL]
    axios
      .post(url, params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

/**
 * delete方法，对应delete请求
 * @param {String} url 请求的url地址
 * @param {Object} params 请求时携带的参数
 * @param {String} baseURL 基础URL，默认为'OPS'
 * @returns {Promise}
 */
export function $delete(url, params, baseURL = 'OPS') {
  return new Promise((resolve, reject) => {
    axios.defaults.baseURL = URL[baseURL]
    axios
      .delete(url, params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
